import calendarUrl from '@library/assets/images/calendar.svg';

export interface DatePickerCalendarIconProps {
  className?: string;
}

export const DatePickerCalendarIcon = ({
  className = undefined
}: DatePickerCalendarIconProps) => {
  return <img className={className} src={calendarUrl} alt="calendar" />;
};
